const style = {
  adModalConfirmation: {
    '& h2': {
      fontSize: '18px'
    },
    textAlign: 'left'
  },
  adModalDesc: {
    backgroundColor: 'aliceblue',
    padding: '8px 16px',
    marginBottom: '8px',
    borderRadius: '8px',
    '& p': {
      margin: 0,
      overflowWrap: 'break-word',
      textAlign: 'left'
    }
  },
  adModalBtnsSection: {
    margin: '24px 8px 13px',
    display: 'flex',
    justifyContent: 'space-between'
  },
  adModalChildren: {
    margin: `0 auto 25px`
  },
}

export default style;